import { useEffect } from 'react';
import API_BASE from '../api';

const REF_STORAGE_KEY = 'canaxe_ref';
const REF_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 jours

/**
 * Hook de tracking d'affiliation.
 * - Détecte ?ref=CODE dans l'URL au montage
 * - Stocke le code dans localStorage avec TTL 30 jours
 * - Expose getStoredRefCode() pour le récupérer lors du signup
 */
export const useAffiliateTracking = () => {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const refCode = params.get('ref');
        if (refCode && refCode.length >= 4) {
            const payload = {
                code: refCode.toUpperCase().trim(),
                expiresAt: Date.now() + REF_TTL_MS,
            };
            localStorage.setItem(REF_STORAGE_KEY, JSON.stringify(payload));
            console.log('[Affiliation] Code de parrainage détecté et sauvegardé:', payload.code);
        }
    }, []);
};

/**
 * Retourne le code de parrainage stocké s'il est encore valide, sinon null.
 */
export const getStoredRefCode = () => {
    try {
        const raw = localStorage.getItem(REF_STORAGE_KEY);
        if (!raw) return null;
        const { code, expiresAt } = JSON.parse(raw);
        if (Date.now() > expiresAt) {
            localStorage.removeItem(REF_STORAGE_KEY);
            return null;
        }
        return code;
    } catch {
        return null;
    }
};

/**
 * Envoie le code au backend pour rattacher le nouveau user à son parrain.
 * Appeler juste après la création de compte Firebase.
 */
export const linkReferral = async (newUid, refCode) => {
    if (!newUid || !refCode) return;
    try {
        const res = await fetch(`${API_BASE}/api/affiliate/signup-with-ref`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ newUid, refCode }),
        });
        const data = await res.json();
        if (data.success) {
            console.log('[Affiliation] Filleul rattaché avec succès au parrain', data.affiliateUid);
            localStorage.removeItem(REF_STORAGE_KEY); // Nettoyage après usage
        }
    } catch (e) {
        console.warn('[Affiliation] Erreur rattachement parrain:', e.message);
    }
};
